import { HeapCustomEvent, HeapService } from "shared-services";
import { checkIsAgent, getUserAttribute, UserAttributes } from "shared-auth";
import { useQueryClient } from "react-query";
import { ISelfTapeRequest } from "shared/models/selfTapeRequest";
import { selfTaperRequestQueryKey } from "pages/SelfTapeRequestPage/constants";

export function useTrackSelfTapeHeapEvent(selfTapeRequestId: string) {
  const queryClient = useQueryClient();
  const selfTape = queryClient.getQueryData<ISelfTapeRequest>([
    selfTaperRequestQueryKey,
    selfTapeRequestId,
  ]);
  const isAgent = checkIsAgent();

  return (event: HeapCustomEvent) => {
    if (selfTape)
      HeapService.track(event, {
        "Request ID": selfTapeRequestId,
        "Breakdown ID": selfTape.breakdownId,
        "Agent ID": isAgent && getUserAttribute(UserAttributes.UserIdAgent),
        "Performer ID": selfTape.performer.id,
        "Casting Director ID": selfTape.castingDirector.id,
      });
  };
}
